import * as types from './types'
import http from '@/Plugins/api'

export default {
  setPager({ commit }, data) {
    commit(types.SET_PAGER, data)
  },
  resetFeed({ commit }) {
    commit(types.RESET_FEED)
  },
  resetFeedPost({ commit }, data) {
    commit(types.RESET_FEED_POST, data)
  },
  resetFeedComment({ commit }, data) {
    commit(types.RESET_COMMENT, data)
  },
  setFeedPostData({ commit }, data) {
    commit(types.SET_FEED_POST_DATA, data)
  },
  setCommentData({ commit }, data) {
    commit(types.SET_COMMENT_DATA, data)
  },
  async setFeedPostLike({ commit }, data) {
    const r = await http.post(`v2/wallmessagelike/${data.id}`, {
      like: data.like,
    })
    commit(types.SET_FEED_POST_LIKE, {
      like: data.like,
      data: r.data.data,
    })
    return r.data.data
  },
  async getFeed({ commit }, data) {
    const r = await http.get(`v2/wallmessages`, {
      params: data,
    })
    commit(types.SET_FEED, r.data.data)
    return r.data.data
  },
  async getFeedPost({ commit }, id) {
    const r = await http.get(`v2/wallmessages/${id}`)
    commit(types.SET_FEED_POST, r.data.data)
    return r.data.data
  },
  async saveFeedPost({ commit }, data) {
    const r = await http.post(`v2/wallmessages`, data)
    return r.data.data
  },
  async saveFeedPostForm({ commit }, data) {
    const r = await http.post(`v2/wallmessage/form`, data)
    return r.data.data
  },
  async setFeedPostRead({ commit }, data) {
    const r = await http.put(`v2/wallmessagesread`, data)
    return r.data.data
  },
  async editFeedPost({ commit }, data) {
    const r = await http.put(`v2/wallmessages/${data.id}`, data)
    return r.data.data
  },
  async deleteFeedPost({ commit }, id) {
    const r = await http.delete(`v2/wallmessages/${id}`)
    return r.data.data
  },
  async undeleteFeedPost({ commit }, id) {
    const r = await http.put(`v2/wallmessagesundelete/${id}`)
    return r.data.data
  },
  async saveFeedComment({ commit }, data) {
    const r = await http.post(`v2/wallmessages/comments/${data.feed_id}`, data)
    commit(types.SET_COMMENT, {
      id: null,
      action: 1,
      data: r.data.data,
    })
    return r.data.data
  },
  async editFeedComment({ commit }, data) {
    const r = await http.put(`v2/wallmessages/comments/${data.id}`, data)
    commit(types.SET_COMMENT, {
      id: data.id,
      action: 2,
      data: r.data.data,
    })
    return r.data.data
  },
  async deleteFeedComment({ commit }, id) {
    const r = await http.delete(`v2/wallmessages/comments/${id}`)
    commit(types.SET_COMMENT, {
      id: id,
      action: 3,
      data: r.data.data,
    })
    return r.data.data
  },
}
